import { Metadata } from "./metadata";

export class Notification {
  public id: number;
  public title: string;
  public description: string;
  public type: string;
  public image: string;
  public imageNotification: string;
  public metadata: Metadata;
  public isRead: boolean;
  public created_at: string;

  constructor(
    id = 0,
    title = "",
    description = "",
    type = "",
    image = "",
    imageNotification = "",
    metadata = new Metadata(),
    isRead = false,
    created_at = ""
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.type = type;
    this.image = image;
    this.metadata = metadata;
    this.isRead = isRead;
    this.created_at = created_at;
    this.imageNotification = imageNotification;
  }
}
